import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { FavouriteButton } from 'widgets/player-awards-tracker/js/common/FavouriteButton';
import { getTranslation } from 'common/react/utils/translations';
import { PlayerPhoto } from 'common/react/components/PlayerPhoto';
import { composeFiltersString } from '../PlayerCell';
import { useTeamsList, getIsAFLW } from '../../utils';
import { navSelector } from 'common/store/modules/competition-nav/selectors';
import { useActivatePlayerModal } from '../../../../hooks/use-activate-player-modal';

export const MobilePlayerCell = ({
    player,
    onPlayerFavouriteClick,
    favourites,
    seasonPid,
    cellProps,
    shouldHidePredicted,
    isBrownlowV2,
    count,
    status
}) => {
    const nav = useSelector(navSelector);

    const compAbbr = PULSE.app.common.match.getCompAbbr(seasonPid);
    const isAFLW = getIsAFLW(seasonPid);
    const teamsList = useTeamsList(nav?.season.id);

    const teams = [
        { id: -1, name: getTranslation('label.stats.allClubs') },
        ...teamsList.sort((a, b) => a.name.localeCompare(b.name))
    ];
    const seasons = nav?.seasons;

    const activatePlayerModal = useActivatePlayerModal({
        player,
        seasonPid,
        nav,
        shouldHidePredicted,
        isBrownlowV2,
        isAFLW,
        count,
        getFiltersString: () => composeFiltersString(nav, teams, seasons)
    });

    return (
        <div {...cellProps} className={`stats-table__row-header-cell `}>
            <div
                className="stats-table__row-brownlow-player-cell"
                role="rowheader"
                scope="row"
            >
                <FavouriteButton
                    player={player}
                    onPlayerFavouriteClick={onPlayerFavouriteClick}
                    favourites={favourites}
                    isAFLW={isAFLW}
                />

                <PlayerPhoto
                    className="stats-leaders-table-player__headshot"
                    photoUrl={player?.photoURL}
                    alt={`${getTranslation('label.stats.headshot.alt')}`}
                    width="1"
                    height="1"
                />

                <div>
                    <button
                        onClick={(event) => activatePlayerModal(event)}
                        onKeyDown={(event) => activatePlayerModal(event)}
                        className="stats-table__row-brownlow-player-name"
                    >
                        <p>{player.givenName}</p>
                        <p>{player.surname}</p>
                    </button>

                    {!player.eligible && (
                        <span className="stats-table__row-brownlow-ineligible">
                            {getTranslation(
                                'label.brownlow.predictor.ineligible'
                            )}
                        </span>
                    )}
                </div>

                {status &&
                    status ===
                        PULSE.app.common.CONSTANTS.MATCH_STATUS.CONCLUDED &&
                    player.winner && (
                        <img
                            className="stats-table__player-cell-brownlow-badge"
                            src={`/resources/${
                                window.RESOURCES_VERSION
                            }/i/elements/${
                                compAbbr === 'AFLW'
                                    ? 'bandf-medal-gold.svg'
                                    : 'brownlow-gold.svg'
                            }`}
                        />
                    )}
            </div>
        </div>
    );
};

MobilePlayerCell.propTypes = {
    player: PropTypes.object.isRequired,
    onPlayerFavouriteClick: PropTypes.func,
    favourites: PropTypes.array,
    seasonPid: PropTypes.string,
    cellProps: PropTypes.any,
    shouldHidePredicted: PropTypes.any,
    isBrownlowV2: PropTypes.bool,
    count: PropTypes.number,
    status: PropTypes.string
};
